// ==============================|| OVERRIDES - ICON BUTTON ||============================== //

export default function IconButton(theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          width: 'auto',
          height: 'auto',
          padding: '0.4375rem 0.5rem', // Vertical 7px, horizontal 8px (at 16px base)
          '&.MuiIconButton-loading': {
            pointerEvents: 'none !important',
            '& svg': {
              width: 'inherit !important',
              height: 'inherit !important'
            }
          }
        },
        sizeLarge: {
          width: 'auto',
          height: 'auto',
          fontSize: '1.25rem',
          padding: '0.546875rem 0.625rem' // Vertical ~8.75px, horizontal 10px (same 7:8 ratio)
        },
        sizeMedium: {
          width: 'auto',
          height: 'auto',
          fontSize: '1rem',
          padding: '0.4375rem 0.5rem' // Vertical 7px, horizontal 8px (at 16px base)
        },
        sizeSmall: {
          width: 'auto',
          height: 'auto',
          fontSize: '0.875rem',
          padding: '0.328125rem 0.375rem' // Vertical ~5.25px, horizontal 6px (same 7:8 ratio)
        }
      }
    }
  };
}
